var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 17.79L14.1608 17.215C14.565 16.7092 15.4242 16.75 15.765 17.29C16.1758 17.9408 17.1908 17.8117 17.4725 17.2133C17.4875 17.1825 17.4508 17.26 17.4817 16.9908C17.5133 16.7217 17.5 16.66 17.4733 16.5375L15.8717 8.97083C15.4683 7.06833 15.2675 6.1175 14.5742 5.55833C13.8833 5 12.9042 5 10.95 5H9.05249C7.09666 5 6.11916 5 5.42666 5.55833C4.73332 6.11667 4.53249 7.06833 4.12916 8.97L2.52666 16.5367C2.50082 16.66 2.48749 16.7217 2.51832 16.9908C2.54999 17.26 2.51416 17.1825 2.52832 17.2133C2.80999 17.8117 3.82499 17.9417 4.23582 17.2908C4.57749 16.75 5.43582 16.7092 5.83999 17.215L6.29999 17.79C6.87999 18.515 8.09166 18.515 8.67082 17.79L8.74332 17.6992C9.35832 16.9308 10.6433 16.9308 11.2583 17.6992L11.3308 17.79C11.9108 18.515 13.1217 18.515 13.7017 17.79",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06918 7.91699C1.58168 7.41033 1.67335 6.75783 1.67335 5.12699C1.67335 3.49616 1.67335 2.68033 2.16168 2.17366C2.64918 1.66699 3.43335 1.66699 5.00418 1.66699H14.9959C16.5659 1.66699 17.3508 1.66699 17.8392 2.17366C18.3275 2.68033 18.3267 3.49616 18.3267 5.12699C18.3267 6.75783 18.4184 7.41033 17.93 7.91699M10 8.33366H7.50002M11.6667 11.667H6.66668",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.ab543fa460c2e62f665ec0adb79ae81b.svg";
export { ForwardRef as ReactComponent };